export enum DocumentUploadType {
  appointmentTask,
  form,
}

export interface DocumentReference {
  type: DocumentUploadType;
  referenceId: string;
  formQuestionId?: Nullable<string>;
}
